webpackJsonp([14],{

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_swiper__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_swiper__);




var moremoreClick = function moremoreClick() {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-design-detail-more-more').on('click', '', function () {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-design-detail-price-table tr:gt(2)').fadeIn(1000);
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-design-detail-more-more').fadeOut(1000).remove();
  });
};

var start = function start() {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-design-detail-price-table tr:gt(2)').hide();

  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-tileWrap').each(function (_, tileWrap) {
    var $tiles = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(tileWrap).find('.js-tile');
    var max = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()($tiles.map(function (_, tile) {
      return __WEBPACK_IMPORTED_MODULE_1_jquery___default()(tile).outerHeight();
    })));
    $tiles.each(function (_, tile) {
      return __WEBPACK_IMPORTED_MODULE_1_jquery___default()(tile).outerHeight(max);
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(tileWrap).css('background', 'linear-gradient(to top, rgba(255,255,255,1)  0,rgba(255,255,255,1)  ' + max + 'px,rgba(250,250,250,1) ' + max + 'px,rgba(250,250,250,1) ' + (max + 70) + 'px,rgba(255,255,255,0) ' + (max + 70) + 'px,rgba(255,255,255,0) 100%');
  });

  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-switch-price-table').on('click', '', function (e) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.currentTarget).siblings().removeClass('active');
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.currentTarget).addClass('active');
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.currentTarget).closest('.m-styleDetailPrice').find('.m-priceTable').removeClass('active');
    var target = '.js-price-table-' + __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.currentTarget).data('target');
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.currentTarget).closest('.m-styleDetailPrice').find(target).addClass('active');
  });
};

var showAssortImage = function showAssortImage(number) {
  var maxAssortNumber = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-assort-image').length;

  if (number < 0) number = maxAssortNumber - 1;
  if (number >= maxAssortNumber) number = 0;

  var images = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-assort-image');
  var buttons = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-assort-change');

  for (var i = 0; i < maxAssortNumber; i++) {
    if (i === number) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(images[i]).show();
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(buttons[i]).addClass('a-assortChanger__changeButton__active');
    } else {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(images[i]).hide();
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(buttons[i]).removeClass('a-assortChanger__changeButton__active');
    }
  }
};

var changeAssortImage = function changeAssortImage() {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-assort-change').on('touchstart click', function (e) {
    e.preventDefault();

    var number = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target).data('assort-number');
    showAssortImage(number);
  });

  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-assort-next').on('touchstart click', function (e) {
    e.preventDefault();

    var showedNumber = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-assort-image:visible').data('assort-image-number');
    showAssortImage(showedNumber + 1);
  });

  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-assort-back').on('touchstart click', function (e) {
    e.preventDefault();

    var showedNumber = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-assort-image:visible').data('assort-image-number');
    showAssortImage(showedNumber - 1);
  });

  showAssortImage(0);
};

var changeImageDepth = function changeImageDepth() {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-design-thumbnail-back').on({
    'mouseenter': function mouseenter() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-design-thumbnail-container-back').css('z-index', '9');
    },
    'mouseleave': function mouseleave() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-design-thumbnail-container-back').css('z-index', '');
    }
  });
};

var slideView = function slideView() {
  __WEBPACK_IMPORTED_MODULE_2_swiper___default()('.o-stylePrintinfinity .swiper-container', {
    loop: true,
    slidesPerView: 1,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    spaceBetween: 0,
    autoplay: 5000,
    autoplayDisableOnInteraction: false,
    speed: 1000
  });

  __WEBPACK_IMPORTED_MODULE_2_swiper___default()('.swiper-container--sizes', {
    loop: false,
    slidesPerView: 1,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    pagination: '.swiper-pagination',
    spaceBetween: 30,
    speed: 1000
  });

  __WEBPACK_IMPORTED_MODULE_2_swiper___default()('.swiper-container--tab', {
    loop: true,
    slidesPerView: 1,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    spaceBetween: 0,
    parallax: true,
    speed: 1000,
    onSlideChangeStart: function onSlideChangeStart(e) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.m-priceTable').removeClass('active');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.m-priceTable').eq(e.realIndex).addClass('active');
    }
  });
};

__WEBPACK_IMPORTED_MODULE_1_jquery___default()(function () {
  start();
  moremoreClick();
  changeAssortImage();
  changeImageDepth();
  slideView();
});

/***/ })

},[131]);


// WEBPACK FOOTER //
// assets/js/style_detail.js